import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["fileThumb", "fileInput"];

  declare fileThumbTarget: HTMLSpanElement;
  declare fileInputTarget: HTMLInputElement;

  fileSelected(){
    if (!this.fileInputTarget.files)
      return
    const fileThumb = this.fileInputTarget.files[0].name
    this.fileThumbTarget.innerHTML = `<img src='${URL.createObjectURL(this.fileInputTarget.files[0])}' width="300" height="200" >`    
  }
}